import { render, staticRenderFns } from "./sopDetail.vue?vue&type=template&id=3abb5b18&scoped=true&"
import script from "./sopDetail.vue?vue&type=script&lang=js&"
export * from "./sopDetail.vue?vue&type=script&lang=js&"
import style0 from "./sopDetail.vue?vue&type=style&index=0&id=3abb5b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb5b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abb5b18')) {
      api.createRecord('3abb5b18', component.options)
    } else {
      api.reload('3abb5b18', component.options)
    }
    module.hot.accept("./sopDetail.vue?vue&type=template&id=3abb5b18&scoped=true&", function () {
      api.rerender('3abb5b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/sopDetail.vue"
export default component.exports